<template>
  <div class="map">
    <l-map ref="map" style="height: 100%" :zoom="zoom" :center="center" :options="mapOptions" >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-geo-json :options-style="style" :geojson="geojson" :fillOpacity="fillOpacity"></l-geo-json>
        <l-marker 
          v-for="town in towns" 
          v-bind:key="town.id" 
          :icon="town.id === currentSelection ? iconSelected : iconDefault" 
          :zIndexOffset="town.id === currentSelection ? 1000 : 0" 
          :lat-lng="getLatLng(town.lat, town.long)" 
          @click="markerSelect(town)"> </l-marker>
        <l-marker 
          v-if="this.$store.state.userPosition.coords" 
          :icon="iconUserPosition" 
          :lat-lng="getLatLng(this.$store.state.userPosition.coords.latitude, this.$store.state.userPosition.coords.longitude)"> 
          <l-popup>You are here</l-popup>
        </l-marker>
    </l-map>
  </div>
</template>

<script>
import {latLng, icon} from 'leaflet';
import {LMap, LTileLayer, LMarker, LPopup, LGeoJson} from 'vue2-leaflet';
import {mexicoStates} from '@/assets/geoJSON/geodata.js';

export default {
  name: 'Map',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LGeoJson,
  },
  props: {
    zoom: Number,
    isFullscreen: Boolean,
    geojson: Object,
    fillOpacity: Number,
    towns: Array,
  },
  data () {
    return {
      mapOptions: {
        zoomSnap: 0.5,
        attributionControl: false,
        maxZoom: 11,
      },
      center: latLng(this.$store.state.currentTown.lat, this.$store.state.currentTown.long),
      url: 'https://www.jayschroeder.dev/um-vue/map-images/{z}/{x}/{y}.png',
      currentMapLayer: mexicoStates,
      currentSelection: null,
      iconDefault: icon({
        iconUrl: 'leaflet-icons/marker-icon-grey-large.png',
        iconAnchor: [12.5, 41],
        shaddowUrl: 'leaflet-icons/marker-shadow.png',
        shaddowAnchor: [12.5, 41],
        shadowSize:   [41, 41],
        iconSize: [25, 41]
      }),
      iconSelected: icon({
        iconUrl: 'leaflet-icons/marker-icon-coral-large.png',
        shaddowUrl: 'leaflet-icons/marker-shadow.png',
        iconAnchor: [12.5, 41],
        shaddowAnchor: [12.5, 41],
        iconSize: [25, 41],
      }),
      iconUserPosition: icon({
        iconUrl: 'leaflet-icons/marker-icon-teal-large.png',
        shaddowUrl: 'leaflet-icons/marker-shadow.png',
        iconAnchor: [12.5, 41],
        shaddowAnchor: [12.5, 41],
        iconSize: [25, 41],
        popupAnchor: [0, -34],
      })
    }
  },
  mounted(){
    this.center = latLng(this.$store.state.currentTown.lat, this.$store.state.currentTown.long)
    if (this.$store.state.currentTown.id){
      this.currentSelection = this.$store.state.currentTown.id;
      this.$emit("marker-clicked");
    }
  },
  computed: {
    style() {
      return (feature) => {
        const fillColor = feature.properties.fill;
        return {
          weight: .5,
          opacity: .9,
          color: "#000000",      
          fillColor: fillColor? fillColor : "#b5b5b5",
          fillOpacity: this.fillOpacity,
          
        }
      }
    },
  },
  methods: {
    getLatLng(lat, lng){
      return latLng(lat, lng);
    },
    markerSelect(town){
      this.$emit("marker-clicked");
      this.$store.commit("changeCurrentTown", town);
      this.currentSelection = town.id;
    },
    currentLatLong() {
      return this.$store.state.currentLatLong;
    },
    setUserPosition(position){
      console.log('fired')
      this.userCurrentPosition = position;
    },
    positionError(error){
      console.log(error);
    }
  },
  watch: {
    fillOpacity() {
      this.$nextTick(() => {
        this.$refs.map.mapObject.invalidateSize();
      })
    },

    isFullscreen(newValue) {
      for (let i = 0; i < 250; i++){
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.map.mapObject.invalidateSize();

            if (i % 30 === 0 && !newValue) {
              this.center = latLng(this.$store.state.currentTown.lat - i / 100000000, this.$store.state.currentTown.long - i / 10000000);
            }
          });
        }, i)
      }

      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.map.mapObject.invalidateSize();
          this.center = latLng(this.$store.state.currentTown.lat, this.$store.state.currentTown.long);
        });
      }, 252)

    },
    currentLatLong(newValue) {
      this.center = latLng(newValue.lat, newValue.long)
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .map {
    height: 100%;
  }


</style>
